import type { GameState, TickCtx } from './tickTypes'
import { platinumUpgrade6Effect, magicHardcap } from '../transients/index'
import { goldFire } from './tick/goldFire'
import { platinumMagicChallenges } from './tick/platinumMagicChallenges'
import { uraniumEarlySigils } from './tick/uraniumEarlySigils'
import { knowledgeToPlutonium } from './tick/knowledgeToPlutonium'
import { holyPlanets } from './tick/holyPlanets'
import { plagueToFinality } from './tick/plagueToFinality'

// The pure derived-value pipeline: pristine updateSmall's STATE half
// (script.js:1299-2188), transcribed section-by-section in exact statement
// order. Ships in parallel with pristine updateSmall (which keeps driving the
// game) under a continuous equivalence battery until step 11 swaps drivers.
// The DOM half (295 display writes), the alertString banner, and the
// timeStopped guard stay behind in pristine updateSmall.

export const sections = {
  goldFire,
  platinumMagicChallenges,
  uraniumEarlySigils,
  knowledgeToPlutonium,
  holyPlanets,
  plagueToFinality,
} as const

export const SECTION_ORDER = [
  'goldFire',
  'platinumMagicChallenges',
  'uraniumEarlySigils',
  'knowledgeToPlutonium',
  'holyPlanets',
  'plagueToFinality',
] as const

/** ctx wired to the live environment (harness stub clock or real browser). */
export function liveCtx(): TickCtx {
  return {
    now: () => Date.now(),
    transients: { platinumUpgrade6Effect, magicHardcap },
  }
}

export function computeDerived(game: GameState, ctx: TickCtx = liveCtx()): void {
  for (const name of SECTION_ORDER) sections[name](game, ctx)
}
